export default __webpack_public_path__ + "static/media/red-skull.4ff5a69c.svg";